"use client";

import type { ComponentProps } from "react";
import { useLocale } from "next-intl";
import { NumberInput } from "@leabankab/component-library";
import { FormField } from "@leabankab/component-library/react-hook-form";

export type NumberFieldProps = Omit<
	ComponentProps<typeof NumberInput>,
	"name" | "value" | "defaultValue" | "onValueChange" | "error"
> & { name: string };

/**
 * The library `NumberInput`, bound to the surrounding react-hook-form form.
 * Parsed in the app's locale, where comma and dot both read as the decimal
 * separator; the browser's own locale would read "1234,56" as 123 456.
 */
export const NumberField = ({ name, ...props }: NumberFieldProps) => {
	const locale = useLocale();

	return (
		<FormField
			name={name}
			render={({ field }) => (
				<NumberInput
					locale={locale}
					{...props}
					{...field}
					value={field.value ?? null}
				/>
			)}
		/>
	);
};
